import { Box, IconButton } from "@mui/material";
import React from "react";
import CustomDetailBox from "../../applications/summary_tabs/CustomDetailBox";
import CustomTabButton from "../../unit/CustomTabButton";
import LoanModificationLog from "./LoanModificationLog";
import LoanModificationReduceLog from "./LoanModificationReduceLog";
import LoanModificationSkipLog from "./LoanModificationSkipLog";
import LoanModificationPostoneLog from "./LoanModificationPostoneLog";
import LoanOriginalTermsLog from "./LoanOriginalTermsLog";

const LoanModificationPaymentTab = ({ ...props }) => {
  const appId = props.appId;
  const [activeTab, setActiveTab] = React.useState(1);

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100%", pt: 0 }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <CustomTabButton
            id={`tab-loan-modify-org-log-${appId}`}
            variant="text"
            onClick={() => handleChange(1)}
            className={activeTab === 1 ? "Mui-selected" : ""}
          >
            Original Terms
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-modify-log-${appId}`}
            variant="text"
            onClick={() => handleChange(2)}
            className={activeTab === 2 ? "Mui-selected" : ""}
          >
            Modify Loan Terms
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-reduce-log-${appId}`}
            variant="text"
            onClick={() => handleChange(3)}
            className={activeTab === 3 ? "Mui-selected" : ""}
          >
            Reduce Select Payments
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-skip-log-${appId}`}
            variant="text"
            onClick={() => handleChange(4)}
            className={activeTab === 4 ? "Mui-selected" : ""}
          >
            Postpone Next Payment
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-payment-postpone-log-${appId}`}
            variant="text"
            onClick={() => handleChange(5)}
            className={activeTab === 5 ? "Mui-selected" : ""}
          >
            Skip Upcoming Payment
          </CustomTabButton>
        </Box>
      </Box>
      <CustomDetailBox sx={{ display: activeTab === 1 ? "block" : "none" }}>
        <LoanOriginalTermsLog appId={appId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 2 ? "block" : "none" }}>
        <LoanModificationLog appId={appId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 3 ? "block" : "none" }}>
        <LoanModificationReduceLog appId={appId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 4 ? "block" : "none" }}>
        <LoanModificationPostoneLog appId={appId} />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 5 ? "block" : "none" }}>
        <LoanModificationSkipLog appId={appId} />
      </CustomDetailBox>
    </Box>
  );
};

export default LoanModificationPaymentTab;
